import script from "./FinalFormScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinalFormScreen.vue?vue&type=script&setup=true&lang=ts"

import "./FinalFormScreen.vue?vue&type=style&index=0&id=5e7ca1cc&scoped=true&lang=scss"

import exportComponent from "/tmp/plasty-fe-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7ca1cc"]])

export default __exports__